import React, {useState} from "react";
import sha256 from 'js-sha256'
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'
//import {format} from 'date-fns'
import {useSelector} from 'react-redux'

import {monthDropdown} from '../services/functions'
import GooglePlaceSearch from "../components/googlePlaceSearch";


export default function ReportGenZTGSection(props) {

    const navigate = useNavigate();

    const gMapApiKey = process.env.REACT_APP_GOOGLE_MAP_API

    const currentCustomer = useSelector(state => state.currentCustomer)

    const hash = sha256(currentCustomer.user.email);
    const accessToken = localStorage.getItem("accessToken"); // eslint-disable-next-line
    const addZTGReportUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/ztg/add?hash=${hash}`; 
    
    const [buttonText, setButtonText] = useState('Generate');
    const [showSpinner, setShowSpinner] = useState('visually-hidden');

    const [alertStatus, setAlertStatus] = useState({
		status: false,
		message: '',
        errorMessage: []
	});

    const [ztgData, setZtgData] = useState({
		place: '',
        latitude: '',
		longitude: '',
        month: '',
        date: '',
        year: '',
        hour: '',
        minute: '',
        timezone: '',
	})

    const [reportSent, setReportSent] = useState(false)

    
   
    const modalLoaded = () => {
        setReportSent(false)
        setButtonText("Generate")
        setShowSpinner("visually-hidden")
    };

    const modalExited = () => {
        setZtgData({
            ...ztgData,
            'place': '',
            'latitude': '',
            'longitude': '',
            'timezone': '',
            'month': '',
            'date': '',
            'year': '',
            'hour': '',
            'minute': ''
        })
    };
    

    
    
    
    let monthDropdownList = monthDropdown.length > 0
		&& monthDropdown.map((item, i) => {
		return (
			<option key={i} value={item.value}>{item.label}</option>
		)
	}, this)


    
    // year dropdown    
    const yearpre18 = new Date().getFullYear() - 18;
    let yearoptions = [];
    yearoptions.push({
        label:"Year",
        value:""
    })
    for (let i = yearpre18; i > 1919; i--) {
        yearoptions.push({
            label:i,
            value:i
        })
    }

    let getYearList = yearoptions.length > 0
        && yearoptions.map((item, i) => {
        return (
            <option key={i} value={item.value}>{item.label}</option>
        )
    }, this)


    // day dropdown
    let dayoptions = []
    dayoptions.push({
        label:"Day",
        value:""
    })

    for (let i = 1; i <= 31; i++) {
        dayoptions.push({
            label:i,
            value:i
        })
    }
    let getDayList = dayoptions.length > 0
        && dayoptions.map((item, i) => {
        return (
            <option key={i} value={item.value}>{item.label}</option>
        )
    }, this)


    // Hour dropdown
    let houroptions = []
    houroptions.push({
        label:"Hours",
        value:""
    })

    for (let i = 0; i <= 23; i++) {
        houroptions.push({
            label:i,
            value:i
        })
    }
    let getHourList = houroptions.length > 0
        && houroptions.map((item, i) => {
        return (
            <option key={i} value={item.value}>{item.label}</option>
        )
    }, this)

    // Minutue dropdown
    let minuteoptions = []
    minuteoptions.push({
        label:"Minutes",
        value:""
    })

    for (let i = 0; i < 60; i++) {
        minuteoptions.push({
            label:i,
            value:i
        })
    }
    let getMinuteList = minuteoptions.length > 0
        && minuteoptions.map((item, i) => {
        return (
            <option key={i} value={item.value}>{item.label}</option>
        )
    }, this)

    const handleDataChange = (data) => {
        //console.log("objectval"+data.latitude+"==="+data.longitude)

        setZtgData({
            ...ztgData,
            'place': data.place,
            'latitude': String(data.latitude),
            'longitude': String(data.longitude)
        })
    }    

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        setZtgData({
            ...ztgData,
            [name]: value
        })
    }

    // eslint-disable-next-line
    const postZTGReport = (URl, postData) => {        

        axios.post(URl, postData, {
			headers: {
				'Authorization': `Bearer ${accessToken}`
			},
		})
		.then(result => {
            if(result.data.status === 'success')
			{
                setShowSpinner("visually-hidden")
                setButtonText("Generate")
                setReportSent(true)
            }
         })
		.catch((error) => {
			// Error
			if(error.response.status === 401)
			{
				localStorage.clear()
      	        navigate("/login")
			}
		})
	}

    const selectTimezone = () => {
        let latitude = ztgData.latitude;
        let longitude = ztgData.longitude;
      
        let year = ztgData.year;
        let month = ztgData.month;
        let day = ztgData.date;
        let hours = ztgData.hour;
        let minutes = ztgData.minute;
        let seconds = 0;
        let milliseconds = 0;
        let targetDate = new Date(year, month, day, hours, minutes, seconds, milliseconds)
        let timestamp = targetDate.getTime() / 1000 + targetDate.getTimezoneOffset() * 60;
      
        axios.get('https://maps.googleapis.com/maps/api/timezone/json', {
            params: {
                'location': `${latitude},${longitude}`,
                'key': gMapApiKey,
                'timestamp': timestamp
            }
        })
        .then(result => {            
            //console.log("status"+result.data.rawOffset)

            if(result.data.rawOffset !== "") {
                let timezone_val = (parseInt(result.data.dstOffset) + parseInt(result.data.rawOffset)) / 3600;

                setZtgData({
                    ...ztgData,
                    'timezone': String(timezone_val)
                })

                setTimeout(() => {
                    setButtonText("Sending Request")
                    setShowSpinner("")                    
        
                    let ztgPostData = {place: ztgData.place, latitude: ztgData.latitude, longitude: ztgData.longitude, month: ztgData.month, date: ztgData.date, year: ztgData.year, hour: ztgData.hour, minute: ztgData.minute, timezone: String(timezone_val), isAdmin: '1'}
                    postZTGReport(addZTGReportUrl,ztgPostData)
                }, 2500)
            } else {
                setReportSent(false)
                setButtonText("Generate")
                setShowSpinner("visually-hidden")
            }
        })
        .catch(function (error) {
            console.log(error);
        });
      
      }
    

    const handleRequestSend = () => {
        let message = []

        setAlertStatus({
            ...alertStatus,
            'status': false,            
            'errorMessage': ''
        })
        
        if(ztgData.place === "") {
            message.push("Please enter the place")
        }
        if(ztgData.latitude === "" || ztgData.longitude === "") {
            message.push("Please select the place from dropdown for Latitude/Longitude")
        }
        if(ztgData.timezone === "") {
            //message.push("Please select the DOB and TOB for Timezone")
        }
        if(ztgData.month === "") {
            message.push("Please select the Month")
        }
        if(ztgData.date === "") {
            message.push("Please select the Day")
        }
        if(ztgData.year === "") {
            message.push("Please select the Year")
        }
        if(ztgData.hour === "") {
            message.push("Please select the Hour")
        }
        if(ztgData.minute === "") {
            message.push("Please select the Minute")
        }
        

        setAlertStatus({
            ...alertStatus,
            'status': (message.length > 0 ? true : false),
            'errorMessage': message
        })

        if(message.length < 1) {
            setButtonText("Fetching Timezone")
            selectTimezone()
        }
    }

    return (
        <>
        <div>
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered 
                show={props.ztgShow} 
                onHide={() => props.onHide({ msg: 'Icon Clicked!' })}
                onEntered={modalLoaded}
                onExit={modalExited}
            >
            <Modal.Header closeButton>
                <Modal.Title>
                    {props.ztgTitle}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="app-card app-card-orders-table mb-5">
                    <div className="app-card-body">
                        <div className="row">
                        {alertStatus.status ? (
                            <div className="w-100">
                                <div className={`alert alert-danger fade show ms-4 me-4`}>

                                {alertStatus.errorMessage.map((messageData,i) => {
                                    return (
                                        <ul key={i}>
                                            <li className="fw-bold">{messageData}</li>
                                        </ul>
                                    )
                                })}
                                    
                                </div>
                            </div>
                        ) : '' }
                        </div>
                        <div className="row">
                            <h5>Place</h5>
                            <div className="col">
                                <GooglePlaceSearch onDataChange={handleDataChange} />
                            </div>
                        </div>
                        <div className="clearb"></div>
                        <div className="row mt-3">
                            <h5>Location</h5>
                            <div className="col">
                                <input type="text" name="latitude" placeholder="latitude" readOnly className="form-control latitude bg-light" id="ztg_latitude" value={ztgData.latitude} onChange={handleInputChange} />
                            </div>
                            <div className="col">
                                <input type="text" name="longitude" placeholder="longitude" readOnly className="form-control longitude bg-light" id="ztg_longitude" value={ztgData.longitude} onChange={handleInputChange} />
                            </div>
                            <div className="col">
                                <input type="text" name="timezone" placeholder="timezone" readOnly className="form-control timezone bg-light" id="ztg_timezone" value={ztgData.timezone} onChange={handleInputChange} />
                            </div>
                            <div className="clearb"></div>
                            <div className="row ms-1 text-danger">above fields will be autofill after filling the complete form</div>
                        </div>
                        <div className="clearb"></div>
                        <div className="row mt-3">
                            <h5>Date of Birth</h5>
                            <div className="col">
                                <select name="month" className="form-select" id="ztg_month" data-style="btn-primary" onChange={handleInputChange}>
                                    {monthDropdownList}
                                </select>
                            </div>
                            <div className="col">
                                <select name="date" className="form-select" id="ztg_day" onChange={handleInputChange}>
                                    {getDayList}
                                </select>
                            </div>
                            <div className="col">
                                <select name="year" className="form-select" id="ztg_year" onChange={handleInputChange}>
                                    {getYearList}
                                </select>
                            </div>
                        </div>
                        <div className="clearb"></div>
                        <div className="row mt-3">
                            <h5>Time of Birth</h5>
                            <div className="col">
                                <select name="hour" className="form-select" id="ztg_hour" onChange={handleInputChange}>
                                    {getHourList}
                                </select>
                            </div>
                            <div className="col">
                                <select name="minute" className="form-select" id="ztg_minute" onChange={handleInputChange}>
                                    {getMinuteList}
                                </select>
                            </div>                            
                        </div>
                        <div className="clear"></div>
                        <div className="row mt-4">                            
                            <div className="form_group">
                                <button type="submit" className="btn btn-primary" onClick={handleRequestSend}>
                                    <span className={`spinner-grow spinner-grow-sm me-1 ${showSpinner}`}></span>
                                    <span className="">{buttonText}</span>
                                </button>
                                {reportSent ? <span className="mx-1 text-success">Your Report Request Has Been Sent. Please check after sometime.</span> : ''}
                            </div>
                        </div>                        
                    </div>
                </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => props.onClick({ msg: 'Modal Closed!' })} >Close</Button>                        
                </Modal.Footer>

            </Modal>
        </div>
        </>
    )
}